import React from "react";

function ServiceItem(props) {
  return (
    <div className="col-sm-6 col-lg-6">
      <div className="service-item">
        <figure className="service-thumb">
          <a
            href={"/files/" + props.file}
            target="_blank"
            rel="noopener noreferrer"
            className="stretched-link"
          >
            <img
              src={require("../../assets/img/media/packageimage/" +
                props.image)}
              alt={props.title}
            />
          </a>

          <figcaption className="service-txt" >
            <h5 className="text-left ml-3" style={{fontWeight:"500"}}> {props.title}</h5>
          </figcaption>
         <h3 className="text-left ml-5 " style={{fontWeight:"600"}}>symptoms</h3>

        </figure>
        {/* <div className="service-content">
          <div className="service-content-inner">
            <img
              src={require("../../assets/img/separator20.svg")}
              alt=""
              className="dlIcon"
            />
            <h5>
              <a
                href={"/files/" + props.file}
                target="_blank"
                rel="noopener noreferrer"
                className="stretched-link"
              >
                {props.title}
              </a>
            </h5>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default ServiceItem;
